module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "tag-item",
    attrs: {
      "to": {
        name: 'tag',
        params: {
          language: _vm.language,
          slug: _vm.slug
        }
      }
    }
  }, [(_vm.language === "en" && _vm.description) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-198a2cfd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsTagItemInline.vue
// module id = 212
// module chunks = 2